import React, { Component, Fragment } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactGA from 'react-ga';
import * as usersActions from '../../redux/actions/usersActions';
import history from '../../utils/history';

import ScrollToTop from './ScrollToTop';
import PrivateRoute from './PrivateRoute';
import ProtectedPrivateRoute from './ProtectedPrivateRoute';
import AppAdminRoute from './AppAdminRoute';
import JwtRoute from './JwtRoute';
import Navbar from './Navbar';
import Footer from './Footer';
import TokenExpiredModal from './TokenExpiredModal';

import SplashPage from '../pages/SplashPage';
import DashboardPage from '../pages/DashboardPage';
import DownloadPage from '../pages/DownloadPage';
import HelpPage from '../pages/HelpPage';
import NewAssessmentPage from '../pages/NewAssessmentPage';
import NewAssessmentPrefacePage from '../pages/NewAssessmentPrefacePage';
import NewAssessmentIntroPage from '../pages/NewAssessmentIntroPage';
import CompleteAssessmentPage from '../pages/CompleteAssessmentPage';
import QuestionPage from '../pages/QuestionPage';
import NewAssessmentOutroPage from '../pages/NewAssessmentOutroPage';
import LoginPage from '../pages/LoginPage';
import AboutPage from '../pages/AboutPage';
import NotFoundPage from '../pages/NotFoundPage';
import AssessmentsPage from '../pages/AssessmentsPage';
import ResourcesPage from '../pages/ResourcesPage';
import AccountPage from '../pages/AccountPage';
import RegisterPage from '../pages/RegisterPage';
import UsersPage from '../pages/UsersPage';
import SpecPage from '../pages/SpecPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import ReviewPage from '../pages/ReviewPage';
import WelcomePage from '../pages/WelcomePage';
import JoinPage from '../pages/JoinPage';
import ActionPlanPage from '../pages/ActionPlanPage';
import BugReportPage from '../pages/BugReportPage';

class SiteRouter extends Component {
  constructor(props) {
    super(props);
    ReactGA.initialize('UA-122865887-1', { /* debug: true */ });
    ReactGA.pageview(window.location.pathname + window.location.search);
    this.previousLocation = window.location.pathname + window.location.search;
  }

  trackPageview = () => {
    // If we've truly changed to a new route, send a pageview to Google Analytics
    if (this.previousLocation !== window.location.pathname + window.location.search) {
      this.previousLocation = window.location.pathname + window.location.search;
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  render() {
    const { loggedIn, tokenExpired, dispatchUsersActions } = this.props;
    return (
      <Router history={history}>
        <Fragment>
          <Helmet
            onChangeClientState={this.trackPageview}
            defaultTitle="RTA MedSafety"
            titleTemplate="%s – RTA MedSafety"
          />
          <ScrollToTop />
          <div className="body-content">
            <div className="body-content__main">
              <Navbar
                loggedIn={loggedIn}
                usersActions={dispatchUsersActions}
              />
              <Switch>
                {/* dynamic homepage */}
                <Route
                  exact
                  path="/"
                  render={() => (loggedIn
                    ? <DashboardPage />
                    : <SplashPage />
                  )}
                />

                {/* public paths */}
                <Route exact path="/about" component={AboutPage} />
                <Route exact path="/download" component={DownloadPage} />
                <Route exact path="/reference-list" component={ResourcesPage} />
                <Route exact path="/login" component={LoginPage} />
                <Route exact path="/register" component={RegisterPage} />
                <Route exact path="/forgot-password" component={ForgotPasswordPage} />
                <Route exact path="/reset-password" component={ResetPasswordPage} />
                <Route exact path="/spec-page" component={SpecPage} />
                <Route exact path="/privacy-policy" component={PrivacyPolicyPage} />
                <Route exact path="/welcome" component={WelcomePage} />
                <Route exact path="/join" component={JoinPage} />

                {/* private paths */}
                <PrivateRoute exact path="/help" component={HelpPage} />
                <PrivateRoute exact path="/help/:slug" component={HelpPage} />
                <PrivateRoute exact path="/resources" component={ActionPlanPage} />
                <ProtectedPrivateRoute exact path="/assessments/new" component={NewAssessmentPage} />
                <ProtectedPrivateRoute exact path="/assessments/:assessmentId/preface" component={NewAssessmentPrefacePage} />
                <ProtectedPrivateRoute exact path="/assessments/:assessmentId/intro" component={NewAssessmentIntroPage} />
                <ProtectedPrivateRoute exact path="/assessments/:assessmentId/final-comments" component={NewAssessmentOutroPage} />
                <ProtectedPrivateRoute exact path="/assessments/:assessmentId/complete" component={CompleteAssessmentPage} />
                <ProtectedPrivateRoute exact path="/assessments/:assessmentId/:questionIndex" component={QuestionPage} />
                <PrivateRoute exact path="/assessments" component={AssessmentsPage} />
                <JwtRoute exact path="/review" component={ReviewPage} />
                <PrivateRoute exact path="/account/users" component={UsersPage} />
                <PrivateRoute exact path="/account" component={AccountPage} />

                {/* app admin paths */}
                <AppAdminRoute exact path="/bug-reports" component={BugReportPage} />

                {/* 404 catch */}
                <Route component={NotFoundPage} />
              </Switch>
            </div>
            <Footer className="body-content__footer" />
          </div>
          <TokenExpiredModal
            visible={tokenExpired}
          />
        </Fragment>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: state.users.currentUserId && sessionStorage.jwt,
    tokenExpired: state.status.tokenExpired,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatchUsersActions: bindActionCreators(usersActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SiteRouter);



// WEBPACK FOOTER //
// ./src/components/common/Router.js